import { render, staticRenderFns } from "./MyAdItemTrailerChips.vue?vue&type=template&id=0212baaf&scoped=true"
import script from "./MyAdItemTrailerChips.vue?vue&type=script&lang=js"
export * from "./MyAdItemTrailerChips.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0212baaf",
  null
  
)

export default component.exports